import React from 'react';

export const HelpIcon: React.FC<{ className?: string }> = ({ className }) => (
  <span className={`material-symbols-outlined ${className}`}>
    quiz
  </span>
);